import React from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  TextField,
  Select,
  Container,
  MenuItem,
  InputLabel,
  Button,
  Paper,
  CssBaseline,
  FormControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  Tabs,
  Tab,
  Typography,
  Tooltip,
} from "@mui/material";
import {
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import SaveIcon from "@mui/icons-material/Save";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { toast } from "react-toastify";
import swal from "sweetalert";
import TabPanel from "../common/TabPanel";
import { connect } from "react-redux";
import * as companyApi from "../../api/companyApi";
import * as countryApi from "../../api/countryApi";
import { withRouter } from "../common/WithRouter";
import { nb } from 'date-fns/locale';


class CompanyDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company: {},
      companyStatus: {},
      companyTypes: [],
      countries: [],
      membership: "tff",
      page: 0,
      pagePrizeHistory: 0,
      pageCapitalCallHistory: 0,
      rowsPerPage: 25,
      users: [],
      errors: {},
      tabIndexValue: 0,
      companiesByOrg: [],
      openNewDialog: false,
      openEditDialog: false,
      membershipStatus: [],
      prizeHistoryType: "ReportedPrize",
      prizeHistory: [],
      CapitalCallHistory: [],
      open: false,
      newTFFcode: 0,
      roles: [],
      sortDirection: "asc",
      originalMainCode: [],
      multipleMainCodes: null
    };
  }

  async componentDidMount() {
    try {
      const companyId = this.props.params?.id || this.props.signedin?.companyId || JSON.parse(sessionStorage.getItem("token")).companyId;
      const company = await companyApi.getCompany(companyId);
      if (company) {
        const sortedCodes = [...company.codeTFF].sort((a, b) => (b.mainCode === true) - (a.mainCode === true));
        company.codeTFF = sortedCodes;

        const allMainCodes = company.codeTFF?.filter((c) => c.mainCode) || [];
        const originalMainCode = allMainCodes.map((c) => c.code);
        const selectedMainCode = allMainCodes.length > 0 ? allMainCodes[0].code : null;

        this.setState({
          company,
          selectedMainCode,
          multipleMainCodes: allMainCodes.length > 1,
          originalMainCode
        });
      };

      await this.getUser();
      await this.getCompanyTypes();
      await this.getCompanyStatus(companyId);
      await this.getCountries();
      await this.getUsers(companyId);
      await this.getCompanyByOrg();
      await this.getMembershipStatusForCompany(companyId);
      await this.getPrizeHistory();
      await this.getCapitalCallHistory();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getUser = async () => {
    const userRoles = this.props.signedin?.userRoles || JSON.parse(sessionStorage.getItem("token")).userRoles || "";
    this.setState({ roles: userRoles ? userRoles.map(role => role.roleName) : [] });
  };

  getCompany = async () => {
    const company = await companyApi.getCompany(this.state.company.companyId);
    if (company) {
      this.setState({ company });
    } else {
      this.setState({ company: [] });
    }
  };

  getUsers = async (companyId) => {
    const users = await companyApi.getUsers(companyId);
    if (users) {
      this.setState({ users });
    }
  };
  getCompanyTypes = async () => {
    const companyTypes = await companyApi.getCompanyTypes();
    if (companyTypes) this.setState({ companyTypes });
  };

  getCompanyByOrg = async () => {
    const companiesByOrg = await companyApi.getCompaniesByOrg(this.state.membership);
    if (companiesByOrg) {
      companiesByOrg.sort((a, b) => a.companyName.localeCompare(b.companyName));
      this.setState({ companiesByOrg });
    }
  };

  getCountries = async () => {
    const countries = await countryApi.getCountries();
    if (countries) this.setState({ countries });
  };

  getCompanyStatus = async (companyId) => {
    const companyStatus = await companyApi.getCompanyStatus(companyId, this.state.membership);
    this.setState({ companyStatus: companyStatus || [] });
  };

  getMembershipStatusForCompany = async (companyId) => {
    const membershipStatus = await companyApi.getMembershipStatusForCompany(companyId, this.state.membership);
    this.setState({ membershipStatus: membershipStatus || [] });
  };

  getPrizeHistory = async () => {
    const { company, membership, prizeHistoryType } = this.state;
    const prizeHistory = await companyApi.getPrizeHistory(company.companyId, membership, prizeHistoryType);

    if (prizeHistory) {
      prizeHistory.sort((a, b) => b.prizeYear - a.prizeYear);
    }

    this.setState({ prizeHistory: prizeHistory || [] });
  };

  getCapitalCallHistory = async () => {
    const { company, membership } = this.state;
    const capitalCallHistory = await companyApi.getCapitalCallHistory(company.companyId, membership);
    this.setState({ capitalCallHistory: capitalCallHistory || [] });
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      company: { ...prevState.company, [name]: value }
    }));
  };

  onSave = async (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    const cleanedCompany = {
      ...this.state.company,
      codeTFF: this.state.company.codeTFF.map((c) => String(c.code)),
    };
    const companySaved = await companyApi.saveCompany(cleanedCompany);
    companySaved ? toast.success("Bedrift lagret.")
      : toast.error("Det skjedd noe feil...");
  };

  formIsValid = () => {
    const errors = {};
    if (!this.state.company.companyTypeId) errors.companyTypeId = "Bedriftstype er påkrevd";
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleChangeTabEvent = (event, newValue) => this.setState({ tabIndexValue: newValue });

  handleChangePage = (event, newPage) => this.setState({ page: newPage });

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleChangePagePrizeHistory = (event, newPage) => {
    this.setState({ pagePrizeHistory: newPage });
  };

  handleChangeRowsPerPagePrizeHistory = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ pagePrizeHistory: 0 });
  };

  handleChangePageCapitalCallHistory = (event, newPage) => {
    this.setState({ pageCapitalCallHistory: newPage });
  };

  handleChangeRowsPerPageCapitalCallHistory = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ pageCapitalCallHistory: 0 });
  };

  handleClickNewDialogBoxOpen = () => {
    this.setState({ openNewDialog: true });
  };

  handleClickEditDialogBoxOpen = () => {
    this.getCompanyByOrg();
    this.setState({ openEditDialog: true });
  };

  handleDialogBoxClose = async () => {
    this.setState({ openEditDialog: false });
    this.setState({ openNewDialog: false });
  };

  handleRadioButtonChange = async (event) => {
    try {
      const membership = event.target.value || "tff";
      await this.setState({ membership });

      const { companyId } = this.state.company;
      this.getMembershipStatusForCompany(companyId, membership);
      this.getCompanyStatus(companyId);
      this.getPrizeHistory();
      this.getCapitalCallHistory();
    } catch (error) {
      console.log(error);
    }
  };

  handlePrizeHistory = async (membership) => {
    await this.setState({ prizeHistory: [] });
    if (this.state.prizeHistoryType === "rapported") {
      await this.getReportedPrizeHistory();
    } else {
      await this.getOwnedPrizeHistory();
    }
  };

  handleDialogBoxChange = (e) => {
    try {
      const name = e.target.name;
      const value = e.target.value;
      const companyStatus = { ...this.state.companyStatus };
      if (name === "activeMember") {
        companyStatus.activeMember = !companyStatus.activeMember
      } else {
        companyStatus[name] = value;
      }
      this.setState({ companyStatus });
    } catch (error) {
      console.log("Error in handleDialogBoxChange", error);
    }
  };

  handleSaveNewMemberStatus = async () => {
    this.setState({ openNewDialog: false });
    const company = { ...this.state.company };
    const { membership, companyStatus } = this.state;
    const status = await companyApi.createCompanyStatus(
      company.companyId,
      membership,
      companyStatus
    );

    if (status) {
      let membershipStatus = [...this.state.membershipStatus];
      membershipStatus.push(status);
      this.setState({ membershipStatus });
      toast.success("Ny Medlemstatus lagret");
    }

    if (membership === "tff") {
      company.tffStatusName = "";
    }
    if (membership === "yff") {
      company.yffStatusName = "";
    }
    this.setState({ company });

    this.getCompanyStatus(company.companyId, membership);
  };

  handleSaveMemberStatus = async () => {
    this.setState({ openEditDialog: false });

    const { company, membership, companyStatus } = this.state;

    const status = await companyApi.updateCompanyStatus(
      company.companyId,
      membership,
      companyStatus
    );

    if (status) {
      this.getMembershipStatusForCompany(company.companyId, membership);
      toast.success("Ny Medlemstatus lagret");

      this.getCompanyStatus(company.companyId);
    }
  };

  handleNewDateChange = (date) => {
    try {
      const companyStatus = { ...this.state.companyStatus };
      companyStatus.fromDate = date;
      this.setState({ companyStatus });
    } catch (error) {
      console.log("Error in onChange", error);
    }
  };

  handleDateChange = (date) => {
    try {
      const companyStatus = { ...this.state.companyStatus };
      if (date < companyStatus.fromDate) {
        this.setState({ error: "Velge dato " });
      }
      companyStatus.fromDate = date;
      this.setState({ companyStatus });
    } catch (error) {
      console.log("Error in onChange", error);
    }
  };

  handleRadioButtonChangePrizeHistory = async (event) => {
    try {
      const prizeHistoryType = event.target.value;
      await this.setState({ prizeHistoryType });
      this.getPrizeHistory();
    } catch (error) {
      console.log(error);
    }
  };

  displayMembershipButton = (membership) => {
    if (
      (this.state.company.tffStatusName === "Ikke medlem" &&
        membership === "tff") ||
      (membership === "yff" &&
        this.state.company.yffStatusName === "Ikke medlem")
    ) {
      return (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => this.handleClickNewDialogBoxOpen()}
        >
          Bedriften er ikke medlem i {membership}, trykk her for å melde inn
        </Button>
      );
    } else {
      return (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => this.handleClickEditDialogBoxOpen()}
        >
          Trykk her for å redigere medlemstatus i {membership}
        </Button>
      );
    }
  };

  handledownloadPrizeHistory = async () => {
    const { company, membership, prizeHistoryType } = this.state;
    const excelfile = await companyApi.getExcelFilePrizeHistory(
      company.companyId,
      membership,
      prizeHistoryType,
      true
    );
    if (excelfile === false) {
      toast.error("Noe gikk feil...");
    }
  };

  handleDownloadCapitalCallHistory = async () => {
    const { company, membership } = this.state;
    const excelfile = await companyApi.getExcelFileCapitalCallHistory(
      company.companyId,
      membership,
      true
    );
    if (excelfile === false) {
      toast.error("Noe gikk feil...");
    }
  };

  handleClick = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };


  handleChangeTFFCode = (e) => {
    const raw = e.target.value;

    const sanitized = raw.replace(/\D/g, "").slice(0, 4);

    this.setState({ newTFFcode: sanitized });
  };

  handleChangeMainCode = (selectedCode) => {
    this.setState((prevState) => ({
      company: {
        ...prevState.company,
        codeTFF: prevState.company.codeTFF.map((c) => ({
          ...c,
          mainCode: c.code === selectedCode,
        })),
      },
    }));
  };


  handleSaveTFFCode = async () => {
    const { company, newTFFcode, originalMainCode } = this.state;

    const isAddingNewCode = newTFFcode && newTFFcode !== "";
    const newMainCode = company.codeTFF
      .filter((c) => c.mainCode)
      .map((c) => parseInt(c.code, 10));
    const isMainCodeChanged = JSON.stringify(originalMainCode.sort()) !== JSON.stringify(newMainCode.sort());

    if (!isAddingNewCode && !isMainCodeChanged) {
      this.setState({ errorCode: "Ingen endringer registrert" });
      return;
    }

    let newCodeSuccess = true;
    let mainCodeSuccess = true;

    if (isAddingNewCode) {
      const response = await companyApi.saveTFFCode(company.companyId, parseInt(newTFFcode, 10));
      if (!response.success) {
        newCodeSuccess = false;
      }
    }

    if (isMainCodeChanged) {
      try {
        const response = await companyApi.setMainTFFCode(company.companyId, newMainCode);
        if (!response.success) {
          newCodeSuccess = false;
        }
      } catch (error) {
        console.error("Failed to update hovedkode:", error);
        mainCodeSuccess = false;
      }
    }

    if (newCodeSuccess && mainCodeSuccess) {
      swal("Endringer lagret!", { icon: "success" });
    } else if (newCodeSuccess || mainCodeSuccess) {
      let msg = "Delvis lagret:\n";
      if (!newCodeSuccess) msg += "- Feil ved lagring av ny TFF-kode\n";
      if (!mainCodeSuccess) msg += "- Feil ved oppdatering av hovedkode";
      swal(msg, { icon: "warning" });
    } else {
      swal("Ingen endringer ble lagret. Prøv igjen.", { icon: "error" });
    }

    if (newCodeSuccess || mainCodeSuccess) {
      this.setState(
        {
          newTFFcode: "",
          errorCode: "",
        },
        () => this.getCompany()
      );
    }
  };

  handleDeleteTFFCode = async (code) => {
    swal({
      title: "Slette TFF code?",
      text: code,
      icon: "warning",
      dangerMode: true,
      buttons: ["Avbryt", "OK"],
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await companyApi.deleteTFFCode(code);
          if (response) {
            swal("TFF kode er slettet!", {
              icon: "success",
            });

            // Update local company state
            const updatedCompany = {
              ...this.state.company,
              codeTFF: this.state.company.codeTFF.filter((c) => c.code !== code),
            };

            // Also update selectedMainCode if deleted
            const deletedMainCode = this.state.originalMainCode === code;

            this.setState({
              company: updatedCompany,
              selectedMainCode: deletedMainCode ? null : this.state.originalMainCode,
            });
          } else {
            swal("Det oppsto en feil...", {
              icon: "error",
            });
          }
        } catch (error) {
          console.log(error);
          swal("En uventet feil oppsto...", {
            icon: "error",
          });
        }
      }
    });
  };


  toggleMainCode = (code) => {
    const updatedCodes = this.state.company.codeTFF.map((c) =>
      c.code === code ? { ...c, mainCode: !c.mainCode } : c
    );

    this.setState({
      company: {
        ...this.state.company,
        codeTFF: updatedCodes,
      },
    });
  };

  compareBy = (key, direction) => {
    return function (a, b) {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    };
  };

  sortBy = (key) => {
    const { prizeHistory, sortDirection } = this.state;
    const newDirection = sortDirection === "asc" ? "desc" : "asc";

    const sortedArray = [...prizeHistory].sort(this.compareBy(key, newDirection));

    this.setState({
      prizeHistory: sortedArray,
      sortDirection: newDirection
    });
  };

  render() {

    const gridPaddingTop = {
      paddingTop: 20,
    };

    const root = {
      width: "100%",
    };
    const tableWrapper = {
      maxHeight: "auto",
      overflow: "auto",
    };

    const head = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
    };

    const emptyPaper = {
      height: 50,
      textAlign: "center",
      paddingTop: 15,
    };

    const button = {
      paddingTop: 15,
    };

    const link = {
      textDecoration: "none",
      color: "#673ab7",
    };

    const columns = [
      { id: "fullName", label: "Navn" },
      { id: "userEmail", label: "E-post" },
    ];
    const membeshipStatusColumns = [
      { id: "fromDate", label: "Fra", minWidth: 100 },
      { id: "toDate", label: "Til", minWidth: 100 },
      { id: "activeMember", label: "Aktiv", minWidth: 100 },
      { id: "conferredCompanyName", label: "Overdratt", minWidth: 100 },
      { id: "comment", label: "Kommentar", minWidth: 100 },
    ];

    const prizeHistoryColumns = [
      { id: "companyName", label: "Navn" },
      { id: "", label: "" },
      ...(this.state.membership === "tff"
        ? [{ id: "reportedCodeTff", label: "TFF Kode", align: "center" }]
        : []),
      { id: "prizeYear", label: "År" },
      {
        id: "amount",
        label: "Beløp",
        align: "right",
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "percentShare",
        label: "Andel(%)",
        align: "right",
        format: (value) =>
          value.toLocaleString(undefined, {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          }),
      },
    ].filter(Boolean);

    const capitalCallHistoryColumns = [
      { id: "year", label: "År" },
      { id: "month", label: "Måned" },
      { id: "incidentYear", label: "Skadeår" },
      { id: "marketShareYear", label: "Andelsår" },
      {
        id: "total",
        label: "Total",
        align: "right",
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "share",
        label: "Andel(%)",
        align: "right",
        format: (value) =>
          value.toLocaleString(undefined, {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          }),
      },
      {
        id: "amount",
        label: "Beløp",
        align: "right",
        format: (value) => value.toLocaleString("de-DE"),
      },
      { id: "", label: "" },
    ];

    return (
      <Container maxWidth="lg">
        <main style={{ width: "100%", paddingTop: 80 }}>
          <Paper sx={{ paddingLeft: 3, paddingTop: 2 }}>
            <CssBaseline />
            <Tabs value={this.state.tabIndexValue} onChange={this.handleChangeTabEvent} variant="fullWidth" textColor="primary" indicatorColor="primary">
              <Tab icon={<InfoOutlinedIcon />} label="Bedrift informasjon" />
              <Tab icon={<PermIdentityIcon />} label="Medlemskap" />
            </Tabs>

            <TabPanel value={this.state.tabIndexValue} index={0}>
              <Grid container spacing={2}>
                <Grid item lg={6}>
                  <Typography variant="h6" sx={{ mb: 2 }}>Informasjon</Typography>
                  <form onSubmit={this.onSave}>
                    <Grid item xs={12}>
                      <TextField
                        name="companyName"
                        label="Navn"
                        value={this.state.company.companyName || ""}
                        onChange={this.onChange}
                        fullWidth
                        required
                        variant="standard"
                      />
                    </Grid>

                    <Grid item xs={12} style={gridPaddingTop}>
                      <FormControl required fullWidth>
                        <InputLabel>Bedrift Type</InputLabel>
                        <Select
                          name="companyTypeId"
                          value={this.state.company.companyTypeId || ""}
                          onChange={this.onChange}
                          error={this.state.errors.companyTypeId}
                          variant="standard"
                        >
                          {this.state.companyTypes.map((companyType, index) => (
                            <MenuItem key={index} value={companyType.companyTypeId}>
                              {companyType.companyTypeName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} style={gridPaddingTop}>
                      <TextField
                        name="orgnr"
                        label="Org. nummer"
                        value={this.state.company.orgnr || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid item xs={12} style={gridPaddingTop}>
                      <TextField
                        name="visitingAddress"
                        label="Besøksadresse"
                        value={this.state.company.visitingAddress || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid item xs={12} style={gridPaddingTop}>
                      <TextField
                        name="postAddress"
                        label="Postadresse"
                        value={this.state.company.postAddress || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid container spacing={2} style={gridPaddingTop}>
                      <Grid item xs={6}>
                        <TextField
                          name="zipCode"
                          label="Postnummer"
                          value={this.state.company.zipCode || ""}
                          onChange={this.onChange}
                          fullWidth
                          variant="standard"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          name="postal"
                          label="Sted"
                          value={this.state.company.postal || ""}
                          onChange={this.onChange}
                          fullWidth
                          variant="standard"
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} style={gridPaddingTop}>
                      <FormControl fullWidth variant="standard">
                        <InputLabel>Land</InputLabel>
                        <Select
                          name="countryId"
                          value={this.state.company.countryId || ""}
                          onChange={this.onChange}
                        >
                          {this.state.countries.map((country, index) => (
                            <MenuItem key={index} value={country.countryId}>
                              {country.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} style={gridPaddingTop}>
                      <TextField
                        name="phonenumber"
                        label="Telefon"
                        type="tel"
                        placeholder="+47 12345678"
                        value={this.state.company.phonenumber || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid item xs={12} style={gridPaddingTop}>
                      <TextField
                        name="emailCompany"
                        label="E-post"
                        type="email"
                        value={this.state.company.emailCompany || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    <Grid item xs={12} style={gridPaddingTop}>
                      <TextField
                        name="webpage"
                        label="Nettside"
                        value={this.state.company.webpage || ""}
                        onChange={this.onChange}
                        fullWidth
                        variant="standard"
                      />
                    </Grid>

                    {/* TFF & YFF Fields */}
                    {this.state.company.tffStatusName !== "Ikke medlem" && (
                      <>
                        <Grid item xs={12} style={gridPaddingTop}>
                          <Link href="#" style={link} onClick={this.handleClick}>
                            Klikk her for å vise eller legge inn TFF-kode
                          </Link>
                          {(() => {
                            const mainCount = this.state.company.codeTFF?.filter((c) => c.mainCode).length || 0;
                            if (mainCount !== 1) {
                              return (
                                <Typography color="error" variant="body2" style={{ marginTop: 4 }}>
                                  Feil med TFF-koder, handling kreves
                                </Typography>
                              );
                            }
                            return null;
                          })()}
                        </Grid>
                        <Dialog open={this.state.open} onClose={this.handleClose} fullWidth>
                          <DialogTitle>TFF kode:</DialogTitle>
                          <DialogContent>
                            <Typography variant="body2" style={{ marginBottom: 10 }}>
                              Avhukning angir hvilken kode som er <strong>hovedkode for risikobærer</strong>.
                            </Typography>

                            {Array.isArray(this.state.company.codeTFF) && this.state.company.codeTFF.length > 0 ? (
                              (() => {
                                const mainCodeCount = this.state.company.codeTFF.filter((c) => c.mainCode).length;
                                const noMain = mainCodeCount === 0;
                                const multipleMain = mainCodeCount > 1;

                                return (
                                  <>
                                    {this.state.company.codeTFF.map((codeObj, index) => (
                                      <Grid
                                        container
                                        key={index}
                                        alignItems="center"
                                        spacing={1}
                                        wrap="nowrap"
                                      >
                                        <Grid item>
                                          <Tooltip
                                            title='Sett som hovedkode for risikobærer'
                                            enterDelay={0}
                                            disableInteractive>
                                            <Checkbox
                                              checked={codeObj.mainCode}
                                              onChange={() => this.handleChangeMainCode(codeObj.code)}
                                            />
                                          </Tooltip>
                                        </Grid>
                                        <Grid item xs>
                                          <Typography style={{ marginLeft: codeObj.mainCode ? 0 : 16 }}>
                                            {codeObj.code}
                                          </Typography>
                                        </Grid>
                                        <Grid item>
                                          <Button
                                            style={{ textDecoration: "none", color: "#B22222" }}
                                            onClick={() => this.handleDeleteTFFCode(codeObj.code)}
                                          >
                                            <DeleteForeverIcon />
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    ))}

                                    {noMain && (
                                      <Typography color="error" style={{ paddingTop: 10 }}>
                                        Ingen hovedkode valgt. Vennligst huk av for hovedkode for polisebærer.
                                      </Typography>
                                    )}
                                    {multipleMain && (
                                      <Typography color="error" style={{ paddingTop: 10 }}>
                                        Det er registrert flere koder for risikobærer (hovedkode). Kun én bør være valgt.
                                      </Typography>
                                    )}
                                  </>
                                );
                              })()
                            ) : (
                              <Typography variant="body2">Ingen TFF-koder funnet.</Typography>
                            )}
                          </DialogContent>

                          <DialogTitle>Lag ny TFF kode:</DialogTitle>
                          <DialogContent>
                            <FormControl fullWidth style={{ paddingTop: 10 }}>
                              <TextField
                                name="newTFFcode"
                                label="TFF Kode"
                                placeholder="100-9999"
                                type="text"
                                value={this.state.newTFFcode || ""}
                                onChange={this.handleChangeTFFCode}
                                inputProps={{
                                  min: 100,
                                  max: 9999,
                                  maxLength: 4,
                                  inputMode: "numeric",
                                  pattern: "[0-9]*"
                                }}
                                error={Boolean(this.state.errorCode)}
                                helperText={this.state.errorCode}
                              />
                            </FormControl>
                          </DialogContent>

                          <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                              Avbryt
                            </Button>
                            <Button onClick={this.handleSaveTFFCode} color="primary">
                              Lagre
                            </Button>
                          </DialogActions>
                        </Dialog>

                        <Typography variant="h6" style={{ marginTop: 20 }}>TFF</Typography>
                        <Grid container spacing={2}>
                          <Grid item lg={6}>
                            <TextField
                              name="emailCaseTFF"
                              label="E-post (skade TFF):"
                              type="email"
                              value={this.state.company.emailCaseTFF || ""}
                              onChange={this.onChange}
                              fullWidth
                              variant="standard"
                            />
                          </Grid>
                          <Grid item lg={6}>
                            <TextField
                              name="emailEconomyTFF"
                              label="E-post (økonomi TFF):"
                              type="email"
                              value={this.state.company.emailEconomyTFF || ""}
                              onChange={this.onChange}
                              fullWidth
                              variant="standard"
                            />
                          </Grid>
                        </Grid>
                      </>
                    )}
                    {this.state.company.yffStatusName !== "Ikke medlem" && (
                      <>
                        <Typography variant="h6" style={{ marginTop: 20 }}>YFF</Typography>
                        <Grid container spacing={2}>
                          <Grid item lg={6}>
                            <TextField
                              name="emailCaseYFF"
                              label="E-post (skade YFF):"
                              type="email"
                              value={this.state.company.emailCaseYFF || ""}
                              onChange={this.onChange}
                              fullWidth
                              variant="standard"
                            />
                          </Grid>
                          <Grid item lg={6}>
                            <TextField
                              name="emailEconomiYFF"
                              label="E-post (økonomi YFF):"
                              type="email"
                              value={this.state.company.emailEconomiYFF || ""}
                              onChange={this.onChange}
                              fullWidth
                              variant="standard"
                            />
                          </Grid>
                          <Grid item lg={6}>
                            <TextField
                              name="emailNavContactYFF"
                              label="E-post (NAV-kontakt YFF):"
                              type="email"
                              value={this.state.company.emailNavContactYFF || ""}
                              onChange={this.onChange}
                              fullWidth
                              variant="standard"
                            />
                          </Grid>
                        </Grid>
                      </>
                    )}


                    <Grid item xs={12} style={gridPaddingTop}>
                      <Button
                        startIcon={<SaveIcon />}
                        type="submit"
                        variant="contained"
                        color="primary"
                      >
                        Lagre
                      </Button>
                    </Grid>
                  </form>
                </Grid>

                {/* User List with Pagination */}
                <Grid item lg={6}>
                  <Typography variant="h6">Brukere</Typography>
                  {this.state.users.length > 0 ? (
                    <Paper style={root}>
                      <div style={tableWrapper}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              {columns.map((column) => (
                                <TableCell key={column.id} style={head}>
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.users
                              .slice(
                                this.state.page * this.state.rowsPerPage,
                                this.state.page * this.state.rowsPerPage +
                                this.state.rowsPerPage
                              )
                              .map((row, index) => (
                                <TableRow hover tabIndex={-1} key={index}>
                                  {columns.map((column) => (
                                    <TableCell key={column.id}>{row[column.id]}</TableCell>
                                  ))}
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </div>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={this.state.users.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />
                    </Paper>
                  ) : (
                    <Paper style={emptyPaper}>
                      Ingen brukere finnes i {this.state.company.companyName || "bedrift"}
                    </Paper>
                  )}
                </Grid>
              </Grid>
            </TabPanel>



            <TabPanel value={this.state.tabIndexValue} index={1}>
              <Grid container spacing={2}>
                {/* Membership Selection */}
                <Grid item lg={6}>
                  <Typography variant="h6">Medlemskap</Typography>
                  <RadioGroup
                    name="group"
                    value={this.state.membership}
                    onChange={this.handleRadioButtonChange}
                    row
                  >
                    <FormControlLabel value="tff" control={<Radio color="primary" />} label="TFF" />
                    <FormControlLabel value="yff" control={<Radio color="primary" />} label="YFF" />
                  </RadioGroup>

                  {/* Membership Actions */}
                  {(this.state.roles.includes("FNO") || this.state.roles.includes("Admin")) && (
                    <div>
                      {this.displayMembershipButton(this.state.membership)}

                      {/* New Membership Status Dialog */}
                      <Dialog open={this.state.openNewDialog} fullWidth onClose={this.handleDialogBoxClose}>
                        <DialogTitle>Innmeldingsinformasjon {this.state.membership.toUpperCase()}</DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nb}>
                            <DatePicker
                              label="Startdato"
                              value={this.state.companyStatus.fromDate || null}
                              onChange={this.handleNewDateChange}
                              sx={{ mt: 2 }}
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                            />
                          </LocalizationProvider>

                          <TextField
                            name="comment"
                            label="Kommentar"
                            value={this.state.companyStatus.comment}
                            onChange={this.handleDialogBoxChange}
                            fullWidth
                            style={{ marginTop: 20 }}
                          />

                          <FormControlLabel
                            style={{ marginTop: 20 }}
                            control={
                              <Checkbox
                                name="activeMember"
                                checked={this.state.companyStatus.activeMember}
                                onChange={this.handleDialogBoxChange}
                                color="primary"
                              />
                            }
                            label="Aktiv"
                          />
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={this.handleDialogBoxClose} color="primary">Avbryt</Button>
                          <Button onClick={this.handleSaveNewMemberStatus} color="primary">Lagre</Button>
                        </DialogActions>
                      </Dialog>

                      {/* Edit Membership Status Dialog */}
                      <Dialog open={this.state.openEditDialog} fullWidth onClose={this.handleDialogBoxClose}>
                        <DialogTitle>Redigere Medlemsstatus {this.state.membership.toUpperCase()}</DialogTitle>
                        <DialogContent>
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nb}>
                            <DatePicker
                              label="Startdato"
                              value={this.state.companyStatus.fromDate || null}
                              onChange={this.handleNewDateChange}
                              sx={{ mt: 2 }}
                              renderInput={(params) => (
                                <TextField {...params} fullWidth />
                              )}
                            />
                          </LocalizationProvider>

                          <FormControl fullWidth style={{ marginTop: 20 }} variant="outlined">
                            <InputLabel shrink>Overdratt</InputLabel>
                            <Select
                              name="conferred"
                              value={this.state.companyStatus.conferred || ""}
                              onChange={this.handleDialogBoxChange}
                              label="Overdratt"
                            >
                              {this.state.companiesByOrg.map((company, index) => (
                                <MenuItem key={index} value={company.companyId}>
                                  {company.companyName} ({this.state.membership.toUpperCase()})
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <TextField
                            name="comment"
                            label="Kommentar"
                            value={this.state.companyStatus.comment}
                            onChange={this.handleDialogBoxChange}
                            fullWidth
                            style={{ marginTop: 30 }}
                          />

                          <FormControlLabel
                            style={{ marginTop: 20 }}
                            control={
                              <Checkbox
                                name="activeMember"
                                checked={this.state.companyStatus.activeMember}
                                onChange={this.handleDialogBoxChange}
                                color="primary"
                              />
                            }
                            label="Aktiv"
                          />
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={this.handleDialogBoxClose} color="primary">Avbryt</Button>
                          <Button onClick={this.handleSaveMemberStatus} color="primary">Lagre</Button>
                        </DialogActions>
                      </Dialog>
                    </div>
                  )}
                </Grid>

                {/* Membership Status Table */}
                {(this.state.membership === "tff" && this.state.company.tffStatusName !== "Ikke medlem") ||
                  (this.state.membership === "yff" && this.state.company.yffStatusName !== "Ikke medlem") ? (
                  <>
                    <Grid item lg={12} sx={{ mt: 4 }}>
                      <Typography variant="h6">Medlemstatus i {this.state.membership.toUpperCase()}</Typography>
                      {this.state.membershipStatus.length > 0 ? (
                        <Paper style={{ width: "100%", overflow: "auto" }}>
                          <Table stickyHeader>
                            <TableHead>
                              <TableRow>
                                {membeshipStatusColumns.map((column) => (
                                  <TableCell key={column.id} style={{ fontWeight: "bold" }}>
                                    {column.label}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.membershipStatus
                                .slice(
                                  this.state.page * this.state.rowsPerPage,
                                  this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                                )
                                .map((status, index) => (
                                  <TableRow key={index} hover>
                                    {membeshipStatusColumns.map((column) => {
                                      let value = status[column.id] || "";

                                      if (column.id === "fromDate" || column.id === "toDate") {
                                        if (value) {
                                          const dateObj = new Date(value);
                                          const day = String(dateObj.getDate()).padStart(2, "0");
                                          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                                          const year = dateObj.getFullYear();
                                          value = `${day}/${month}/${year}`;
                                        }
                                      } else if (column.id === "activeMember") {
                                        value = status[column.id] ? "Ja" : "Nei";
                                      }

                                      return (
                                        <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
                                          {value}
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                ))}
                            </TableBody>
                            <TablePagination
                              rowsPerPageOptions={[10, 25, 100]}
                              component="div"
                              count={this.state.membershipStatus.length}
                              rowsPerPage={this.state.rowsPerPage}
                              page={this.state.page}
                              onPageChange={this.handleChangePage}
                              onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                          </Table>
                        </Paper>
                      ) : (
                        <Typography variant="body1" style={{ textAlign: "center", marginTop: 20 }}>
                          Ingen Medlemstatus i {this.state.membership.toUpperCase()}
                        </Typography>
                      )}
                    </Grid>
                  </>
                ) : null}
              </Grid>
              <Grid item lg={12} style={gridPaddingTop}>
                <Typography variant="h6">Premiehistorikk</Typography>
                <Grid>
                  <RadioGroup row>
                    <Tooltip
                      title={
                        <span style={{ fontSize: 15 }}>
                          Premieandeler opprinnelig innrapportert av dette medlemmet
                        </span>
                      }
                      placement="bottom"
                    >
                      <FormControlLabel
                        value="ReportedPrize"
                        control={<Radio color="primary" />}
                        checked={this.state.prizeHistoryType === "ReportedPrize"}
                        onChange={this.handleRadioButtonChangePrizeHistory}
                        label="Rapporterte"
                      />
                    </Tooltip>
                    <Tooltip
                      title={
                        <span style={{ fontSize: 15 }}>
                          Premieandeler dette medlemmet i øyeblikket står som eier av
                        </span>
                      }
                      placement="bottom"
                    >
                      <FormControlLabel
                        value="OwnedPrize"
                        control={<Radio color="primary" />}
                        checked={this.state.prizeHistoryType === "OwnedPrize"}
                        onChange={this.handleRadioButtonChangePrizeHistory}
                        label="Eide"
                      />
                    </Tooltip>
                  </RadioGroup>
                  <br />

                  {this.state.prizeHistory && this.state.prizeHistory.length > 0 ? (
                    <>
                      <Paper style={root}>
                        <div style={tableWrapper}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow>
                                {prizeHistoryColumns.map((column) => (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ ...head, cursor: "pointer" }}
                                    onClick={() => this.sortBy(column.id)}
                                  >
                                    {column.label}
                                  </TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.prizeHistory
                                .slice(
                                  this.state.pagePrizeHistory * this.state.rowsPerPage,
                                  this.state.pagePrizeHistory * this.state.rowsPerPage + this.state.rowsPerPage
                                )
                                .map((prize, index) => (
                                  <TableRow hover tabIndex={-1} key={index}>
                                    {prizeHistoryColumns.map((column) => {
                                      let value = prize[column.id];

                                      if (column.id === "amount" && (!value || value === 0) && prize.percentShare > 0) {
                                        value = "Ukjent";
                                      }

                                      return (
                                        <TableCell key={column.id} align={column.align}>
                                          {column.format && typeof value === "number" ? column.format(value) : value}
                                        </TableCell>
                                      );
                                    })}
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </div>
                        <TablePagination
                          rowsPerPageOptions={[10, 25, 100]}
                          component="div"
                          count={this.state.prizeHistory.length}
                          rowsPerPage={this.state.rowsPerPage}
                          page={this.state.pagePrizeHistory}
                          onPageChange={this.handleChangePagePrizeHistory}
                          onRowsPerPageChange={this.handleChangeRowsPerPagePrizeHistory}
                        />
                      </Paper>
                      <div style={button}>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={<CloudDownloadIcon />}
                          onClick={this.handledownloadPrizeHistory}
                        >
                          Vis i Excel
                        </Button>
                      </div>
                    </>
                  ) : (
                    <Paper style={{ height: 50, textAlign: "center", paddingTop: 15 }}>
                      Ingen {this.state.prizeHistoryType === "ReportedPrize" ? "Rapporterte" : "Eide"} premiehistorikk i{" "}
                      {this.state.company.companyName}
                    </Paper>
                  )}
                </Grid>
              </Grid>

              <Grid item lg={12} style={gridPaddingTop}>
                <h4>Innkallingshistorikk</h4>
                {this.state.CapitalCallHistory && this.state.CapitalCallHistory.length > 0 ? (
                  <>
                    <Paper style={root}>
                      <div style={tableWrapper}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              {capitalCallHistoryColumns.map((column) => (
                                <TableCell key={column.id} align={column.align}>
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.CapitalCallHistory
                              .slice(
                                this.state.pageCapitalCallHistory * this.state.rowsPerPage,
                                this.state.pageCapitalCallHistory * this.state.rowsPerPage + this.state.rowsPerPage
                              )
                              .map((capitalCall) => (
                                <TableRow hover tabIndex={-1} key={capitalCall.innkallingId}>
                                  {capitalCallHistoryColumns.map((column) => {
                                    const value = capitalCall[column.id];
                                    return (
                                      <TableCell key={column.id} align={column.align}>
                                        {column.format && typeof value === "number" ? column.format(value) : value}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </div>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={this.state.CapitalCallHistory.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.pageCapitalCallHistory}
                        backIconButtonProps={{ "aria-label": "previous page" }}
                        nextIconButtonProps={{ "aria-label": "next page" }}
                        onPageChange={this.handleChangePageCapitalCallHistory}
                        onRowsPerPageChange={this.handleChangeRowsPerPageCapitalCallHistory}
                      />
                    </Paper>
                    <div style={button}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<CloudDownloadIcon />}
                        onClick={this.handleDownloadCapitalCallHistory}
                      >
                        Vis i Excel
                      </Button>
                    </div>
                  </>
                ) : (
                  <Paper style={{ height: 50, textAlign: "center", paddingTop: 15 }}>
                    Ingen Innkallingshistorikk i {this.state.company.companyName}
                  </Paper>
                )}
              </Grid>

            </TabPanel>

          </Paper>
        </main>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  signedin: state.signedinuserobject?.signedInUser || ""
});

export default connect(mapStateToProps)(withRouter(CompanyDetail));
